var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgOutreachTab = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "connect_without_contact_16dp_3B3B3B_FILL0_wght300_GRAD0_opsz20",
    d: "M129.956-824v-2.124a4.468,4.468,0,0,1-2.257-1.423,3.98,3.98,0,0,1-.976-2.5h1.429a2.729,2.729,0,0,0,.891,1.873,2.765,2.765,0,0,0,1.958.764h3.3a1.641,1.641,0,0,1,1.206.5,1.641,1.641,0,0,1,.5,1.205v1.7Zm3.016-5.275a1.629,1.629,0,0,1-1.205-.5,1.658,1.658,0,0,1-.492-1.211,1.63,1.63,0,0,1,.5-1.205,1.658,1.658,0,0,1,1.211-.492,1.629,1.629,0,0,1,1.205.5,1.658,1.658,0,0,1,.492,1.211,1.63,1.63,0,0,1-.5,1.205A1.658,1.658,0,0,1,132.972-829.275Zm-9.846-2.363a7.169,7.169,0,0,1,2.172-5.274,7.2,7.2,0,0,1,5.279-2.167v1.428a5.822,5.822,0,0,0-4.263,1.75,5.785,5.785,0,0,0-1.759,4.262Zm3.406,0a3.9,3.9,0,0,1,1.181-2.868,3.906,3.906,0,0,1,2.864-1.177v1.428a2.523,2.523,0,0,0-1.852.764,2.522,2.522,0,0,0-.764,1.852ZM116-835.319v-1.7a1.642,1.642,0,0,1,.5-1.206,1.641,1.641,0,0,1,1.205-.5H121a2.766,2.766,0,0,0,1.958-.764,2.728,2.728,0,0,0,.891-1.873h1.439a3.884,3.884,0,0,1-.96,2.486,4.468,4.468,0,0,1-2.284,1.434v2.124Zm3.016-5.275a1.629,1.629,0,0,1-1.205-.5,1.658,1.658,0,0,1-.492-1.211,1.63,1.63,0,0,1,.5-1.205,1.658,1.658,0,0,1,1.211-.492,1.63,1.63,0,0,1,1.205.5,1.658,1.658,0,0,1,.492,1.211,1.63,1.63,0,0,1-.5,1.205A1.658,1.658,0,0,1,119.016-840.593Z",
    transform: "translate(-115.5 844.5)",
    fill: "#0b004e",
    stroke: "rgba(0,0,0,0)",
    strokeWidth: 1
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgOutreachTab, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/outreachTab.06ead8c4.svg";
export { ForwardRef as ReactComponent };